export default __webpack_public_path__ + "static/media/logotext_colorshot.379d08c6.png";